<div
  class="main-bg py-8 w-full overflow-auto"
  [ngClass]="uiState().isNavHidden ? 'h-screen' : 'page-height'"
  >
  @if (isLoading()) {
    <app-loading-spinner text="FAQ" />
  }
  <div
    class="w-full flex items-end justify-start text-center py-4 px-3 mobile-min:px-6"
    [ngStyle]="{
      display:
        (uiState().hideArticle && !uiState().routeHasParams) ||
        !uiState().isMobile
          ? 'block'
          : 'none'
    }"
    >
    <div class="tablet-min:w-1/5 mobile-min:w-1/3 mobile-min:max-w-[250px]">
      <input
        id="search"
        class="w-full py-2 px-4 border h-10 bg-gray-100 dark:bg-gray-700 border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-700 focus:border-blue-700"
        type="search"
        placeholder="Search"
        [formControl]="searchFilterControl"
        />
      </div>
    </div>
    @if (faqsData$ | async; as data) {
      <div
        class="mobile-min:px-6 mobile-max:p-2 flex flex-row items-start justify-center"
        >
        <div
          class="overflow-auto mobile-min:px-3 mobile-max:w-full"
          [ngClass]="uiState().isMobile ? 'mobile-menu' : 'menu'"
      [ngStyle]="{
        display:
          uiState().isMobile && uiState().routeHasParams ? 'none' : 'block'
      }"
          >
          @for(group of data; track group.title){
            <div
              @heightAnimation
              class="faq-group p-1 font-normal tracking-tight mobile-max:text-xl"
              >
              {{ group.title }}
            </div>
            @for( article of group.articles; track article.title ){
              <a
        [routerLink]="[
          uiState().isNavHidden ? '/faqs' : '/app/faqs',
          group.handle,
          article.handle
        ]"
                class="faq-title ml-3 p-2 dark:text-slate-300 text-sm hover:cursor-pointer mobile-max:text-lg flex flex-row items-end justify-between"
        [class.active-article]="
          article.title === articleData().title && !uiState().isMobile
        "
                [ngClass]="{ 'mobile-article': uiState().isMobile }"
                >
                {{ article.title }}
                @if(uiState().isMobile){
                  <mat-icon matSuffix fontIcon="chevron_right"></mat-icon>
                }
              </a>
              } }
            </div>
            @if (articleData()) {
              <div
                class="w-full grow article-container h-full mx-10 px-4 tablet-max:mx-0"
      [ngStyle]="{
        display: uiState().hideArticle ? 'none' : 'block'
      }"
                >
                @if(uiState().isMobile){
                  <div
                    class="flex items-center mb-3 hover:cursor-pointer text-sm"
                    routerLink="../.."
                    >
                    <mat-icon fontIcon="arrow_back"></mat-icon>
                    Back to Menu
                  </div>
                }
                <h1 class="text-3xl font-medium">{{ articleData().title }}</h1>
                <div class="flex flex-row gap-1 mt-2">
                  @for(tag of articleData().tags; track tag){
                    <div
                      class="text-xs rounded-lg light:text-black border border-gray-700 dark:bg-gray-800 px-3 py-1.5 font-normal w-fit"
                      >
                      {{ tag }}
                    </div>
                  }
                </div>
                <div class="my-7">
                  {{ articleData().description }}
                </div>
                <div class="w-full">
                  <mat-tab-group color="accent" class="w-full">
                    <mat-tab labelClass="tab-text" label="Desktop">
                      <div>
                        @for(step of articleData().instructions.desktop.steps; track
                          step){
                          <p class="my-6">{{ step }}</p>
                          } @if(articleData().instructions.desktop.videoURL){
                          <div>
                            <iframe
                              width="420"
                              height="345"
                              [src]="articleData().instructions.desktop.videoURL | safe"
                              allowfullscreen
                            ></iframe>
                          </div>
                        }
                      </div>
                    </mat-tab>
                    <mat-tab label="Mobile" labelClass="tab-text">
                      <div>
                        @for(step of articleData().instructions.mobile.steps; track step){
                          <p class="my-6">{{ step }}</p>
                          } @if(articleData().instructions.mobile.videoURL !== null){
                          <div>
                            <iframe
                              width="420"
                              height="345"
                              [src]="articleData().instructions.mobile.videoURL | safe"
                              allowfullscreen
                            ></iframe>
                          </div>
                        }
                      </div>
                    </mat-tab>
                  </mat-tab-group>
                </div>
              </div>
            }
          </div>
        }
      </div>
